// extracted by mini-css-extract-plugin
export default {"timeline":"timeline_timeline__bSRTJ","currentTimeInterval":"timeline_currentTimeInterval__M-eJ0"};